module.exports = __webpack_public_path__ + "img/website-fliphor.5eef188e.gif";